/* @flow */

export default class SetCompanyBankAccountRequest {
  companyId: number;
  bankCountryId: number;
  bankIdentifier: string;
  bankAccount: string;
  bankAccountCountryMismatchReason: string;
  buyerBlocked: boolean;
  supplierId: number;

  constructor(
    companyId: number = 0,
    supplierId: number = 0,
    bankCountryId: number = 0,
    bankIdentifier: string = '',
    bankAccount: string = '',
    bankAccountCountryMismatchReason: string = ''
  ) {
    this.companyId = companyId;
    this.bankCountryId = bankCountryId;
    this.bankIdentifier = bankIdentifier;
    this.bankAccount = bankAccount;
    this.bankAccountCountryMismatchReason = bankAccountCountryMismatchReason;
    this.supplierId = supplierId;
  }
}